<header class="bg-white shadow-sm">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
    <div class="flex items-center space-x-8">
      <a href="/" tabindex="-1" class="flex items-center">
        <img src="assets/images/ap-logo.png" alt="AGW Logo" class="h-8 rounded-sm" />
        <span class="ml-3 text-lg font-medium text-gray-900">Agency Portal</span>
      </a>
      <nav class="hidden md:flex items-center space-x-4" *ngIf="isLogged">
        <a
          *ngFor="let link of navLinks"
          [routerLink]="link.path"
          routerLinkActive="text-primary"
          class="text-gray-600 font-medium flex items-center space-x-2 hover:text-primary"
        >
          <div class="w-5 h-5 flex items-center justify-center">
            <i [class]="link.icon"></i>
          </div>
          <span>{{ link.label }}</span>
        </a>
      </nav>
    </div>
    <div class="dropdown dropdown-end" *ngIf="isLogged">
      <div
        tabindex="0"
        role="button"
        class="flex items-center space-x-2 text-gray-700 hover:text-primary focus:outline-none"
      >
        <div class="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
          <i class="ri-user-line text-gray-600"></i>
        </div>
        <div class="hidden md:block text-left">
          <p class="text-sm font-medium">{{ ls.getItem('email') }}</p>
          <p class="text-xs text-gray-500">Agency Manager</p>
        </div>
        <div class="w-5 h-5 flex items-center justify-center">
          <i class="ri-arrow-down-s-line"></i>
        </div>
      </div>

      <ul
        tabindex="0"
        class="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52 mt-4"
      >
        <li *ngFor="let link of navLinks" class="md:hidden">
          <a
            #dropdownLink
            [routerLink]="link.path"
            routerLinkActive="text-primary"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="dropdownLink.blur()"
          >
            <i [class]="link.icon" class="mr-2"></i>
            {{ link.label }}
          </a>
        </li>

        <!-- My Agencies submenu -->
        <li tabindex="0" *ngIf="agencies?.length">
          <details class="open:bg-slate-50 rounded" open>
            <summary>My Agencies</summary>
            <ul class="p-2 m-0 max-h-64 overflow-auto list-none before:content-none">
              <li
                *ngFor="let agency of agencies"
                class="rounded mb-1 last:mb-0"
                [ngClass]="{ 'bg-primary/10': agency.id === currentAgency?.id }"
              >
                <a
                  (click)="agency.id !== currentAgency?.id ? switchAgency(agency) : null"
                  class="flex gap-3 items-center px-2 py-1 rounded hover:bg-primary/10"
                >
                  <div
                    class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center font-semibold text-sm text-gray-700"
                    [ngClass]="{ 'ring-2 ring-primary/10': agency.id === currentAgency?.id }"
                  >
                    {{ agency.name.charAt(0).toUpperCase() }}
                  </div>

                  <!-- Agency info -->
                  <div class="flex flex-col">
                    <div class="font-semibold">{{ agency.name }}</div>
                    <div class="text-xs text-gray-500" *ngIf="agency.iata_number">
                      {{ agency.iata_number }}
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </details>
        </li>

        <li><a (click)="openAccountSettings()">Account Settings</a></li>
        <li class="text-red-600">
          <a (click)="authService.logout()">Logout</a>
        </li>
      </ul>
    </div>

    <nav class="flex items-center space-x-4" *ngIf="!isLogged">
      <a
        *ngIf="registerAvailable"
        routerLink="register"
        routerLinkActive="text-primary"
        [routerLinkActiveOptions]="{ exact: true }"
        class="text-gray-600 font-medium flex items-center space-x-2 hover:text-primary"
      >
        <div class="w-5 h-5 flex items-center justify-center">
          <i class="ri-user-add-line"></i>
        </div>
        <span>Register</span>
      </a>
      <a
        class="text-gray-600 font-medium flex items-center space-x-2 cursor-pointer hover:text-primary"
        (click)="login()"
      >
        <div class="w-5 h-5 flex items-center justify-center">
          <i class="ri-login-box-line"></i>
        </div>
        <span>Login</span>
      </a>
    </nav>
  </div>
</header>
